/*
 * @Author: Teemo Ding
 * @Date: 2021-08-19 11:07:35
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-10 14:50:36
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelLogoManagement/LogoWrapper/index.tsx
 */
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { Form } from 'antd';
import React from 'react';
// import Uploader from '@/src/components/Antd/Uploader/UploaderComponent';
import ImageUpLoader from '../Components/ImageUpLoader';
import css from '../css.module.less';

const LogoWrapper = ({
  keyName,
  sectionTitle,
  sectionDescription,
  disabled,
}) => {
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      title={sectionTitle}
      subtitle={sectionDescription}>
      <Form.Item name={keyName} noStyle>
        <ImageUpLoader disabled={disabled} />
      </Form.Item>
    </SectionWrapper>
  );
};

export default LogoWrapper;
